// Transform table data to handle rowComponent structure (for monthly view)
// API format: { rows: [{ kpiValue: "Performance Bonus", rowComponent: [[...], [...], {...}, {...}] }] }
export const transformTableData = (tableData: any) => {
  if (!tableData || !tableData.body || !tableData.body.rows) return tableData;

  const transformedRows = tableData.body.rows
    .map((row: any) => {
      if (Array.isArray(row)) {
        if (row.length > 0 && row[0]?.rowComponent) {
          const newRow = [...row];
          newRow[0] = {
            ...newRow[0],
            children: newRow[0].rowComponent,
          };
          return newRow;
        }
        return row;
      }

      if (
        row &&
        typeof row === "object" &&
        row.rowComponent &&
        Array.isArray(row.rowComponent)
      ) {
        const rowComponent = row.rowComponent;
        const children: any[] = [];
        const mainRowCells: any[] = [];

        rowComponent.forEach((item: any) => {
          if (Array.isArray(item)) {
            const filteredChildRow = item.filter(
              (cell: any) => cell !== undefined && cell !== null
            );
            if (filteredChildRow.length > 0) {
              children.push(filteredChildRow);
            }
          } else if (item && typeof item === "object" && item !== null) {
            mainRowCells.push(item);
          }
        });

        // Create the first cell with children if there are any
        const firstCell: any = {
          kpiValue: row.kpiValue,
          kpiDataType: row.kpiDataType,
          kpiCurrency: row.kpiCurrency,
        };

        if (children.length > 0) {
          firstCell.children = children;
        }

        return [firstCell, ...mainRowCells];
      }

      if (row && typeof row === "object" && !Array.isArray(row)) {
        return [row];
      }

      return row;
    })
    .filter((row: any) => {
      if (!row) return false;
      if (Array.isArray(row)) {
        return row.length > 0 && row[0] !== undefined && row[0] !== null;
      }
      return true;
    });

  return {
    ...tableData,
    body: {
      ...tableData.body,
      rows: transformedRows,
    },
  };
};

// Sanitize table data to filter out undefined/null rows and ensure row[0] exists
export const sanitizeTableData = (tableData: any) => {
  const transformed = transformTableData(tableData);
  if (!transformed || !transformed.body || !transformed.body.rows)
    return transformed;

  return {
    ...transformed,
    body: {
      ...transformed.body,
      rows: transformed.body.rows
        .filter(
          (row: any) =>
            row &&
            Array.isArray(row) &&
            row.length > 0 &&
            row[0] !== undefined &&
            row[0] !== null
        )
        .map((row: any) =>
          row.map((cell: any) => {
            if (cell && typeof cell === "object") {
              return cell;
            }
            if (cell !== undefined && cell !== null) {
              return { kpiValue: cell, kpiDataType: "string" };
            }
            return { kpiValue: null, kpiDataType: "string" };
          })
        ),
    },
  };
};
